var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPetrol = function SvgPetrol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 68 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E7F0",
    d: "M24.656 5.375H13.095c-1.468 0-2.658 1.048-2.658 2.34V24.41c0 1.292 1.19 2.34 2.658 2.34h11.56c1.468 0 2.657-1.048 2.657-2.34V7.715c0-1.292-1.19-2.34-2.657-2.34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.694 11H34.93a2.504 2.504 0 0 1 2.507 2.51v27.865h-20.25V13.498A2.51 2.51 0 0 1 19.694 11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    d: "M36.53 42.5H16.97a.9.9 0 0 1-.639-.282 1 1 0 0 1-.268-.67V13.353c0-.922.349-1.807.97-2.46a3.24 3.24 0 0 1 2.344-1.018h14.734c.88 0 1.724.366 2.348 1.018a3.58 3.58 0 0 1 .978 2.46v28.195a1 1 0 0 1-.268.67.9.9 0 0 1-.639.282m-18.653-1.904h17.746V13.353a1.63 1.63 0 0 0-.447-1.114 1.48 1.48 0 0 0-1.065-.46H19.377c-.397.004-.777.17-1.057.465-.28.294-.44.693-.443 1.11z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E7F0",
    d: "M32.938 15.5H20.562v6.75h12.375z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#8CE99A",
    d: "M56.564 15.229a8.44 8.44 0 0 1-8.436 8.719 8.44 8.44 0 0 1-8.436-8.72c0-3.348 4.354-9.335 6.808-12.434a2.075 2.075 0 0 1 3.265 0c2.445 3.1 6.799 9.086 6.799 12.435",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    d: "M47.537 41.375a4.72 4.72 0 0 1-3.349-1.413 4.84 4.84 0 0 1-1.385-3.396v-5.328a1.95 1.95 0 0 0-.562-1.368 1.9 1.9 0 0 0-1.354-.56h-3.66a.9.9 0 0 1-.646-.272.933.933 0 0 1 0-1.311.9.9 0 0 1 .646-.272h3.66a3.72 3.72 0 0 1 2.645 1.108 3.82 3.82 0 0 1 1.1 2.675v5.328c0 .782.306 1.531.85 2.085a2.9 2.9 0 0 0 2.054.87 2.63 2.63 0 0 0 1.872-.786 2.7 2.7 0 0 0 .776-1.897V17.974l-4.88-10.137a.94.94 0 0 1-.044-.71.93.93 0 0 1 .465-.533.9.9 0 0 1 .7-.044c.23.08.419.25.526.47l5.014 10.336a.95.95 0 0 1 .097.407v19.075c-.001.6-.12 1.193-.348 1.746a4.6 4.6 0 0 1-.984 1.476c-.42.421-.92.755-1.467.98a4.4 4.4 0 0 1-1.727.335"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    d: "M48.047 18.875a3.89 3.89 0 0 1-3.688-2.738 3.87 3.87 0 0 1 1.512-4.332l1-.67a.96.96 0 0 1 1.264.253.945.945 0 0 1-.253 1.263l-1 .681a1.97 1.97 0 0 0-.619 2.525 2 2 0 0 0 2.226.947l1.265-.34a.95.95 0 0 1 .812 1.67.9.9 0 0 1-.331.16l-1.265.341a4.4 4.4 0 0 1-.923.24"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#36354C",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M14.563 46.25h25.5"
  })));
};
export default SvgPetrol;